import { Injectable } from '@angular/core';
import { AppSettings } from '@core/library/app-settings';
import { ApiService } from './api.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService extends BaseService {
  constructor(public apiService: ApiService) {
    super();
    this.BaseURL = AppSettings.URL_Session;
  }

  Delete_LoggedInUser(trackLoading = true) {
    return this.apiService
      .postAPI(this.BaseURL, 'Session/Delete_LoggedInUser', null, trackLoading)
      .then((data) => {
        if (!data || data.HasError) {
          return data;
        }
      });
  }

  Delete_Session() {
    this.apiService.deleteSession();
  }
}
